import React, { useContext } from 'react';

import Tag from '@/components/global/Tag';

import styles from './Tags.module.scss';
import { TagsContext } from './TagsContext';

interface ITags {
  tags?: string[];
}

const Tags: React.FC<ITags> = ({ tags }) => {
  const contextTags = useContext(TagsContext);
  if (!contextTags) return;

  const { tags: renderTags = [] } = contextTags;
  if (!renderTags) return;

  return (
    <div className={styles.container}>
      {renderTags?.map((tag, i) => (
        <Tag key={i} label={tag} />
      ))}
    </div>
  );
};

export default Tags;
